<template>
    <div>
        <!-- 上架信息查看 -->
        <vForm :label-width="100" class="margin-15 clearfix" ref="editform">
            <vCol span="12">
                <vFormItem label="预编码" >
                    {{entrydata.precoding}}
                </vFormItem>
            </vCol>
            <vCol span="12">
                <vFormItem label="项目" >
                    {{getLineName(entrydata.lineId)}}
                </vFormItem>
            </vCol>
            
        </vForm>
        
        <TableList v-bind="handleProps"></TableList>

        <div class="text-right margin-top-15">
            <vButton @click="close">关闭</vButton>
        </div>

    </div>
</template>

<script>
import TableList from '@components/templates/tablelist'
import {
    HttpStoreinNews,
} from '@/service/proddevelop';

import { mapState,mapGetters } from "vuex";

export default {
    props:['entrydata'],
    data(){
        return {
            datalist:[],
        }
    },
    components:{
        TableList
    },
    computed:{
        ...mapGetters('diction',['getNewProductList']),
        handleProps(){
            return {
				columns: [{
                    title: 'ERPSKU',
                    key: "erpSku"
                },
                {
                    title: 'SellerSKU',
                    key: "sellerSku"
                },
                {
                    title: '首单日期',
                    key: "firstOrder"
                },
                {
                    title: '首次上架日期',
                    key: "firstShelves"
                },
                {
                    title: '上架链接',
                    key: "shelvesLink"
                },
                {
                    title: '上架渠道',
                    key: "shelvesAccount"
                },
                {
                    title: '首次采购时间',
                    key: "firstPurchaseDate"
                },
                {
                    title: '首次发船时间',
                    key: "firstShip"
                },
                {
                    title: '首次入库时间',
                    key: "firstWarehouse"
                },
                // {
                //     title: '是否异常',
                //     render:(h,{row})=>{
                //         // console.log(row)
                // return {row.isError?'是':'否'}
                //     }
                // }
                ],
				initFormData: { "search[IN_erpSku]":this.entrydata.erplist, },
				ajaxRequest: HttpStoreinNews,
				startUp: true
			}
        },
    },
    created(){
        // this.update()
    },
    methods:{
        getTimeout(datas){
            console.log(datas)
            if(datas.firstOrder){
                // let number = ((datas.firstOrder ? datas.firstOrder.split(' ')[0].getTime() : '') - (datas.firstWarehouse ? datas.firstWarehouse.split(' ')[0].getTime() : ''))/(24 * 60 * 60 * 1000);
                var startDate = new Date(datas.firstOrder.split(' ')[0]);
                var endDate = new Date(datas.firstWarehouse);
                var msecNum = startDate.getTime() - endDate.getTime();
                var dayNum = Math.floor(msecNum /this.getDifferScale());
                console.log(dayNum)
                return number > 7 ? '是' : '否'
            }else{
                return '否'
            }
        },
        getDifferScale(){
            //获取转化比（天数跟毫秒数的比例）
            return parseFloat(24 * 60 * 60 * 1000);
        },
        update(){
            HttpStoreinNews({
                "search[IN_erpSku]":this.entrydata.erplist,
                rows:1000,
                page:1,
            }).then(res=>{
                this.datalist = res.data.content
            })
        },
        getLineName(val){
            let linename = this.getNewProductList.filter(item=>{
                return item.value === val
            })[0] || {}
            return linename.label
        },
        close(){
            this.$emit('on-close')
        }
    },
}
</script>